import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useDispatch } from "react-redux";
import MessageText from "../ChatMessage/MessageText";

type EditMessageHintArgs = {
  chatId: string;
  text: string;
};
export default function EditMessageHint({ chatId, text }: EditMessageHintArgs) {
  const dispatch = useDispatch();

  function removeMessageToEdit(e) {
    e.preventDefault();
    dispatch({ type: "chat/COMPOSER/SET_MESSAGE_TO_EDIT", id: "", chatId });
  }

  return (
    <div className="w-full bg-white text-sm flex flex-col gap-2 p-2 items-start rounded">
      <div className="w-full flex justify-between">
        <div className="flex gap-2 items-center ml-1">
          <FontAwesomeIcon icon={faPencil} />
          {I18n.t("js.chat.room.message.edit.title")}
        </div>
        <button className="btn btn-sm p-0" onClick={removeMessageToEdit}>
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
      <div className="chat__quote !w-full !border-none rounded">
        <MessageText text={text} />
      </div>
    </div>
  );
}
